import type { UseQueryResult } from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { communityKeys } from './key-factory'

export interface CommentsCountType {
  commentsCount: number
  communityPostId: number
}

interface UseCommentsCountOptions extends Omit<
  UseQueryClearOptions<CommentsCountType[], Error, CommentsCountType[]>,
  'enabled'
> {
  communityPath?: string
  postsIds?: number[]
}

export const useCommentsCount = ({
  communityPath,
  postsIds,
  ...options
}: UseCommentsCountOptions): UseQueryResult<CommentsCountType[], Error> => {
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.get, CommentsCountType[]>(
    {
      method: RequestMethodsEnum.get,
    },
  )

  return useQuery(
    queryOptions({
      queryKey: communityKeys.postsCommentsCount(communityPath, postsIds),
      queryFn: () => {
        const searchParams = new URLSearchParams()
        postsIds?.forEach(postId => searchParams.append('ids[]', String(postId)))

        return fetcher(
          `${COMMUNITY_API_PREFIX}/${communityPath}/posts/comments-count?${searchParams.toString()}`,
        )
      },
      enabled: Boolean(communityPath && postsIds?.length),
      ...options,
    }),
  )
}
